import { useState } from 'react';
import logo from './images/logo.png';
import './styles.css';
import axios from 'axios';
import { useNavigate } from 'react-router';
window.utoken="";
window.ulogin="";
window.uname="";
window.utype="";
function Login() {
  let [spnVisible,setSpinVisible]=useState("none");
  let [msg,setMsg]=useState("");
  let nav=useNavigate();
  async function doLogin(event)
  {
    event.preventDefault();
    setMsg("");
    setSpinVisible("block");
    document.getElementById("btnSubmit").className="btn btn-primary mt-3 disabled";
    let s1=document.getElementById("txtLogin").value;
    let s2=document.getElementById("txtPassword").value;        
    
    const apiClient = axios.create({
      baseURL: process.env.REACT_APP_APIURL, // Replace with your API base URL
      headers: {
        'Content-Type': 'application/json'
      }
    });    
    await apiClient.post("/api/User/Login",{login:s1,password:s2}).then(reply=>
    {
      if(reply.status==200)
      {
        if(reply.data.status=="Error")
        {
          setMsg("Invalid Login/Password!!!");
          document.getElementById("txtPassword").focus();
        }
        else if(reply.data.status=="OK")
        {
          window.ulogin=reply.data.data.ulogin;
          window.utype=reply.data.data.utype;
          window.uname=reply.data.data.uname;
          window.utoken=reply.data.data.token;
          localStorage.setItem("token",reply.data.data.token);
          localStorage.setItem("uname",reply.data.data.uname);
          localStorage.setItem("ulogin",reply.data.data.ulogin);
          localStorage.setItem("utype",reply.data.data.utype);
          if(reply.data.data.utype=="admin")
            nav("/admin");          
        }
        else
        {
          setMsg("Unknown Error!!!");
        }
      }
    });    
    //nav("/admin");
    setSpinVisible("none");
    document.getElementById("btnSubmit").className="btn btn-primary mt-3";
  }
  return (
    <div className='row'>
      <div className='col-xxl-4 col-xl-4 col-lg-3 col-md-2 col-sm-1 col-12'></div>
      <div className='col-xxl-4 col-xl-4 col-lg-6 col-md-8 col-sm-10 col-12'>
          <div className='card mt-5 shadow'>
            <div className='card-header h4 text-center'>
                <img src={logo} style={{width:'50px'}} /><br/>
                Member Authentication
            </div>
            <div className='card-body'>
                <form onSubmit={doLogin}>
                  <div className='form-group'>
                    <input type="text" id="txtLogin" placeholder='Enter Login/Email' className='form-control' required />
                  </div>
                  <div className='form-group mt-2'>
                    <input type="password" id="txtPassword" placeholder='Enter Password' className='form-control'  required />
                  </div>
                  <div className='d-flex'>
                    <button id="btnSubmit"  className='btn btn-primary mt-3' >Authenticate</button> 
                    <div style={{height:'20px', margin:'20px'}}><span style={{display:spnVisible}} className='spinner-border'></span></div>
                    <div className='text-danger mt-4'>{msg}</div>
                  </div>
                  
                </form>
            </div>
          </div>
      </div>
      <div className='col-xxl-4 col-xl-4 col-lg-3 col-md-2 col-sm-1 col-12'></div>
      <hr className='mt-5' />
      <center>All Rights Reserved Copyrights {new Date().getFullYear()}</center>
    </div>
    
  );
}
export default Login;
